import { useEffect, useState } from 'react';

import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { assistantApis } from '../../../apis/assistantApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Title from '../../../components/elements/title/Title';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import List from '../../../components/sections/list/List';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';

const AssistantListPage = () => {
  const { projectId } = useParams();
  const { showToast } = useToast();
  const { t } = useTranslation();

  const [assistantList, setAssistantList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: assistantRes } =
        await assistantApis.getAssistantInstanceList(projectId);
      setAssistantList(assistantRes.content);
    } catch (error) {
      showToast(
        TOAST_TYPE.ERROR,
        t('fetch', { ns: 'errors', content: t('instance', { ns: 'instance' }) })
      );
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <Loading />;

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={t('fetch', {
          ns: 'errors',
          data: t('instance', { ns: 'instance' }),
        })}
      />
    );

  return (
    <Container>
      <Breadcrumbs />
      <Title text={t('instance', { ns: 'assistant', count: 2 })} />
      <List data={assistantList} />
    </Container>
  );
};

export default AssistantListPage;
